import { Injectable, signal } from '@angular/core';
import { ClientService } from './client.service';
import { APIUrl } from '../constant/api-call';
import _ from 'underscore';
import { BehaviorSubject, finalize, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  public APIObj = APIUrl;
  public selectedProject = signal<any | null>(
    JSON.parse(sessionStorage.getItem('selected_project') || 'null')
  );
  private _projectMaster = signal<any[]>([]);
  private _userMaster = signal<any[]>([]);
  private _userCategoryMaster = signal<any[]>([]);
  private _masterTypes = signal<any[]>([]);
  public _masterList = signal<any[]>([]);
  public _formList = signal<any[]>([]);
  public _submittedFormList = signal<any[]>([]);
  public _formReport = signal<any[]>([]);
  public formDetails: any[] = [];
  public loading = signal(false);
  public formIdWithData = new BehaviorSubject<any>(null);
  public formIdWithData$ = this.formIdWithData.asObservable();
  public changeProject = new BehaviorSubject<boolean>(false);
  public changeProject$ = this.changeProject.asObservable();
  public reportData = signal<any>(null);
  public dynamicEntryFormData = signal<any>(null);

  constructor(
    private clientService: ClientService) { }

  getMasterData() {
    this.loading.set(true);
    let payload = {
      "project_id": this.selectedProject()?.project_id,
      "tab_name": "USERS_DETAILS,PROJECT_MASTER,USER_CATEGORY_MASTER,MASTER_TYPES,MASTER_DETAILS,FORM_SUBMISSION_LIST,FORM_REPORT_VALUES"
    }
    this.clientService.postAPI(this.APIObj.AUTOPOPULATE_LIST, payload).subscribe((res: any) => {
      if (res && res.data && res.code == 'CSR_MS_OK_200') {
        this._projectMaster.set(res.data[0]?.project_master);
        this._userMaster.set(res.data[0]?.users_details);
        this._userCategoryMaster.set(res.data[0]?.user_category_master);
        this._masterTypes.set(res.data[0]?.master_types);
        this._masterList.set(res.data[0]?.master_details);
        this._submittedFormList.set(res.data[0]?.form_submission_list);
        this._formReport.set(res.data[0]?.form_report_values);
        this.loading.set(false);
      }
      setTimeout(() => {
        this.loading.set(false);
      }, 1000);
    },
      (error) => {
        setTimeout(() => {
          this.loading.set(false);
        }, 1000);
      });
  }

  getFormsProjectWise(projectID?: any) {
    this.loading.set(true);
    this.clientService.getAPI(this.APIObj.FORM_LIST, '?project_id=' + projectID).subscribe((res: any) => {
      if (res && res.data && res.code == 'CSR_MS_OK_200') {
        this._formList.set(res.data);
        this.loading.set(false);
      }
      else {
        this._formList = signal<any[]>([]);
      }
      setTimeout(() => {
        this.loading.set(false);
      }, 1000);
    },
      (error) => {
        setTimeout(() => {
          this.loading.set(false);
        }, 1000);
      });
  }

  getFormDetails(formID?: any): Observable<any> {
    this.loading.set(true);
    return this.clientService.getAPI(this.APIObj.FORM_DETAILS, '?form_id=' + formID).pipe(
      map((res: any) => {
        if (res && res.data && res.code === 'CSR_MS_OK_200') {
          this.formDetails = res.data[0];
          return this.formDetails;
        }
        return null;
      }),
      finalize(() => {
        this.loading.set(false);
      })
    );
  }

  getProjectMaster(): any[] {
    return this._projectMaster();
  }

  getMasterTypes(): any[] {
    return this._masterTypes();
  }

  getFormList(): any[] {
    return this._formList();
  }

  getActiveFormList(): any[] {
    return _.where(this._formList(), { is_active: true });
  }

  getMasterList(): any[] {
    return this._masterList();
  }

  getActiveMasterList(): any[] {
    return _.where(this._masterList(), { is_active: true });
  }

  getSubMasterList(): any[] {
    if (this?._masterList()?.length > 0) {
      return this?._masterList()?.filter((master: any) =>
        master?.sub_master_values_details && master?.sub_master_values_details.length > 0
      );
    }
    return [];
  }

  getSubmittedFormList(): any[] {
    return this._submittedFormList();
  }

  getFormReportData(): any[] {
    return this._formReport();
  }

  getUserData(): any[] {
    return this._userMaster();
  }

  getUserCatData(): any[] {
    return this._userCategoryMaster();
  }

  getPermittedProjects(): any[] {
    const projectIds = sessionStorage.getItem('project_list')?.split(',');
    return this._projectMaster()?.filter((project: any) =>
      projectIds?.includes(project?.project_id?.toString())
    );
  }

  setSelectedProject(projectDetails: any) {
    this.selectedProject.set(projectDetails);
    sessionStorage.setItem('selected_project', JSON.stringify(projectDetails));
  }

  setFormIdWithData(data: any): void {
    this.formIdWithData.next(data);
  }

  getFormIdWithData(): Observable<any> {
    return this.formIdWithData$;
  }

  clearData(): void {
    this.formIdWithData.next(null);
  }

  setChangesProject(data: boolean) {
    this.changeProject.next(data);
  }

  getChangesProject(): Observable<boolean> {
    return this.changeProject$;
  }

  getReportData(): any {
    return this.reportData();
  }

  getDynamicEntryFormData(): any {
    return this.dynamicEntryFormData();
  }
}
